import { render, staticRenderFns } from "./All_Terms.vue?vue&type=template&id=d45c9190&scoped=true&"
import script from "./All_Terms.vue?vue&type=script&lang=js&"
export * from "./All_Terms.vue?vue&type=script&lang=js&"
import style0 from "./All_Terms.vue?vue&type=style&index=0&id=d45c9190&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45c9190",
  null
  
)

export default component.exports